import { AxiosRequestConfig, AxiosResponse } from 'axios';

interface URLItemConfig {
  method: AxiosRequestConfig['method']; // 请求方式
  requestKeys?: string[]; // 入参统一处理字段
  responseKeys?: string[]; // 出参统一处理字段
  requestInterceptor?: (req: AxiosRequestConfig) => AxiosRequestConfig;
  responseInterceptor?: (res: AxiosResponse) => any;
}
type URLConfigMap = Record<string, URLItemConfig>;

// 动态参数接口路径
export const DynamicPathList = [
  '/channel-bills/:id',
  '/crs/order/channel-no/:channelNo',
  '/crs/order/:orderNo',
  '/employee/:id/enable',
  '/employee/management/leave/detail/:id',
  '/employee/management/query/edit/employee/info/:id',
  '/employee/management/employee/detail/:id',
  '/employee/management/query/employee/info/:id',
  '/orders/resv/info/:resvNo',
  '/orders/:resvNo',
  '/priceDiscount/:date',
  '/reservation/detail/:resvNo',
  '/reservation/temp/detail/:resvNo',
  '/rooms/change/detail/:recNo',
  '/transactions/:orderNo',
  '/transactions/:no/consume',
];

// 时区接口配置
export const URLTimeZoneConfig: URLConfigMap = {
  '/approval/detail': { method: 'GET', responseKeys: ['expenseStartDate', 'expenseEndDate'] },
  '/approval/cash-flow/detail': {
    method: 'GET',
    responseKeys: [
      'expenseStartDate',
      'expenseEndDate',
      'costAmortizationStart',
      'costAmortizationEnd',
    ],
  },
  '/query/export': {
    method: 'POST',
    requestKeys: [
      'businessDateStart',
      'businessDateEnd',
      'settleBusinessDateStart',
      'settleBusinessDateEnd',
    ],
  },
  '/sync/revenue': { method: 'POST', requestKeys: ['businessDate'] },
  '/query/page': {
    method: 'POST',
    requestKeys: [
      'businessDateStart',
      'businessDateEnd',
      'settleBusinessDateStart',
      'settleBusinessDateEnd',
    ],
    responseKeys: ['businessDate', 'settleBusinessDate'],
  },
  '/certs/save': { method: 'POST', requestKeys: ['validStartDate', 'validEndDate'] },
  '/certs/detail': { method: 'GET', responseKeys: ['validStartDate', 'validEndDate'] },
  '/certs/page': { method: 'POST', responseKeys: ['validStartDate', 'validEndDate'] },
  '/channel-bills/update': { method: 'PUT', requestKeys: ['startDate', 'endDate'] },
  '/channel-bills/list': {
    method: 'POST',
    requestKeys: ['startDate', 'endDate'],
    responseKeys: ['startDate', 'endDate'],
  },
  '/channel-bills/create': { method: 'POST', requestKeys: ['startDate', 'endDate'] },
  '/channel-bills/:id': { method: 'GET', responseKeys: ['startDate', 'endDate'] },
  '/channel-bills/page': {
    method: 'POST',
    requestKeys: ['startDate', 'endDate'],
    responseKeys: ['startDate', 'endDate'],
  },
  '/channels/strategy/occ-type': { method: 'POST', responseKeys: ['departureDate'] },
  '/channel-order/page': { method: 'POST', responseKeys: ['businessDate'] },
  '/check-in/check': { method: 'POST', requestKeys: ['rentDate'] },
  '/check-in/extension/submit': { method: 'POST', requestKeys: ['rentDay'] },
  '/check-in/create': { method: 'POST', requestKeys: ['rentDate'] },
  '/check-in/append': { method: 'POST', requestKeys: ['rentDate'] },
  '/check-in/modify': { method: 'PUT', requestKeys: ['rentDate'] },
  '/check-in/modify/detail': { method: 'POST', responseKeys: ['rentDate'] },
  '/coupon/choose/one-key': {
    method: 'POST',
    requestKeys: ['startDate', 'endDate', 'rentDate'],
    responseKeys: ['rentDate'],
  },
  '/coupon/availableV2': { method: 'POST', requestKeys: ['businessDate'] },
  '/coupon/calculate': { method: 'POST', requestKeys: ['businessDate'] },
  '/crs/order/channel-no/:channelNo': { method: 'GET', responseKeys: ['businessDate'] },
  '/crs/orderCrsOrderDetail': { method: 'GET', responseKeys: ['time', 'refundTime'] },
  '/crs/order/:orderNo': { method: 'GET', responseKeys: ['businessDate'] },
  '/crs/promotion/save': {
    method: 'POST',
    requestKeys: ['promotionStartTime', 'promotionEndTime'],
  },
  '/crs/promotion/promotionPreCheck': {
    method: 'POST',
    requestKeys: ['promotionStartTime', 'promotionEndTime'],
  },
  '/crs/promotion/enrolledList': {
    method: 'POST',
    requestKeys: ['promotionStartTime', 'promotionEndTime'],
  },
  '/crs/promotion/enrollPromotion': {
    method: 'POST',
    requestKeys: ['promotionStartTime', 'promotionEndTime'],
  },
  '/crs/promotion/detail': {
    method: 'GET',
    responseKeys: ['promotionStartTime', 'promotionEndTime'],
  },
  '/customer-analysis/consume/list': {
    method: 'POST',
    requestKeys: ['startDate', 'endDate', 'comparisonStartDate', 'comparisonEndDate'],
  },
  '/customer-analysis/silent/page': { method: 'POST', requestKeys: ['startDate', 'endDate'] },
  '/employee/roles': { method: 'GET', responseKeys: ['roleExpirationTime'] },
  '/employee/:id/enable': { method: 'POST', requestKeys: ['expireDate'] },
  '/employee/management/update': {
    method: 'POST',
    requestKeys: [
      'joindate',
      'probbegindate',
      'probenddate',
      'conbegindate',
      'conenddate',
      'certenddate',
      'birthday',
      'workbegindate',
      'graduatetime',
      'healthbegindate',
      'healthenddate',
    ],
  },
  '/employee/management/create': {
    method: 'POST',
    requestKeys: ['certenddate', 'birthday', 'graduatetime', 'healthbegindate', 'healthenddate'],
  },
  '/employee/management/leave/detail/:id': { method: 'GET', responseKeys: ['lastWorkDate'] },
  '/employee/management/leave/approval/pass': { method: 'POST', requestKeys: ['lastWorkDate'] },
  '/employee/management/leave/approval/commit': { method: 'POST', requestKeys: ['lastWorkDate'] },
  '/employee/management/query/edit/employee/info/:id': {
    method: 'GET',
    responseKeys: [
      'joindate',
      'probbegindate',
      'probenddate',
      'conbegindate',
      'conenddate',
      'certenddate',
      'birthday',
      'workbegindate',
      'graduatetime',
      'healthbegindate',
      'healthenddate',
    ],
  },
  '/employee/management/employee/detail/:id': { method: 'GET', responseKeys: ['lastWorkDate'] },
  '/employee/management/query/employee/info/:id': {
    method: 'GET',
    responseKeys: [
      'joindate',
      'probbegindate',
      'probenddate',
      'conbegindate',
      'conenddate',
      'certenddate',
      'birthday',
      'workbegindate',
      'graduatetime',
      'healthbegindate',
      'healthenddate',
    ],
  },
  '/rolelist': { method: 'GET', responseKeys: ['roleExpirationTime'] },
  '/roledetail': { method: 'GET', responseKeys: ['roleExpirationTime'] },
  '/expense-submission/update': {
    method: 'POST',
    requestKeys: [
      'expenseStartDate',
      'expenseEndDate',
      'costAmortizationStart',
      'costAmortizationEnd',
    ],
  },
  '/expense-submission/list': {
    method: 'POST',
    requestKeys: ['expenseStartDate', 'expenseEndDate'],
    responseKeys: [
      'expenseStartDate',
      'expenseEndDate',
      'costAmortizationStart',
      'costAmortizationEnd',
    ],
  },
  '/expense-submission/submit': {
    method: 'POST',
    requestKeys: [
      'expenseStartDate',
      'expenseEndDate',
      'costAmortizationStart',
      'costAmortizationEnd',
    ],
  },
  '/expense-submission/submit/verify': {
    method: 'POST',
    requestKeys: ['expenseStartDate', 'expenseEndDate'],
  },
  '/expense-submission/queryById': {
    method: 'GET',
    responseKeys: [
      'expenseStartDate',
      'expenseEndDate',
      'costAmortizationStart',
      'costAmortizationEnd',
    ],
  },
  '/extension/modify/detail': { method: 'GET', responseKeys: ['rentDate'] },
  '/extension/modify': { method: 'PUT', requestKeys: ['rentDate'] },
  '/goods/self-service/accounting/detail': { method: 'POST', responseKeys: ['businessDate'] },
  '/hotel-channel-configlist/by/commonCode': { method: 'GET', responseKeys: ['departureDate'] },
  '/hotel-channel-configlist/dyzl': { method: 'GET', responseKeys: ['rentDay'] },
  '/hotel-channel-configlist/mtzl': { method: 'GET', responseKeys: ['rentDay'] },
  '/hotel-channel-configlist/xczl': { method: 'GET', responseKeys: ['rentDay'] },
  '/hotel-channel-configlist/dynamic': { method: 'POST', responseKeys: ['rentDay'] },
  '/shift/handover/employees': { method: 'POST', requestKeys: ['date'] },
  '/shift/handover/pop-up/bill-list': { method: 'POST', responseKeys: ['businessDate'] },
  '/operate-expenses/findById': {
    method: 'GET',
    responseKeys: ['expenseStartDate', 'expenseEndDate'],
  },
  '/operate-expenses/saveOrUpd': {
    method: 'POST',
    requestKeys: ['expenseStartDate', 'expenseEndDate'],
  },
  '/operate-expenses/page': {
    method: 'POST',
    requestKeys: ['expenseStartDate', 'expenseEndDate'],
    responseKeys: ['expenseStartDate', 'expenseEndDate'],
  },
  '/operate-expenses/list': {
    method: 'POST',
    requestKeys: ['expenseStartDate', 'expenseEndDate'],
    responseKeys: ['expenseStartDate', 'expenseEndDate'],
  },
  '/orders/checked-in': {
    method: 'POST',
    responseKeys: ['businessDate', 'checkoutBusinessDate', 'rentDate'],
  },
  '/orders/resv/info/:resvNo': { method: 'GET', responseKeys: ['businessDate'] },
  '/orders/:resvNo': { method: 'GET', responseKeys: ['businessDate', 'checkoutBusinessDate'] },
  '/orders/checked-out': {
    method: 'POST',
    responseKeys: ['businessDate', 'checkoutBusinessDate', 'rentDate'],
  },
  '/orders/room-orders': {
    method: 'POST',
    responseKeys: ['businessDate', 'checkoutBusinessDate', 'rentDate'],
  },
  '/orders/reserved': {
    method: 'POST',
    responseKeys: ['businessDate', 'checkoutBusinessDate', 'rentDate'],
  },
  '/orders/canceled': {
    method: 'POST',
    responseKeys: ['businessDate', 'checkoutBusinessDate', 'rentDate'],
  },
  '/order/detail/list/sub-status': {
    method: 'POST',
    responseKeys: ['businessDate', 'checkoutBusinessDate'],
  },
  '/order/detail/sub-order': {
    method: 'PUT',
    requestKeys: ['businessDate', 'checkoutBusinessDate'],
  },
  '/ota/gift/list': { method: 'POST', responseKeys: ['startDate', 'endDate'] },
  '/ota/gift/detail': { method: 'GET', responseKeys: ['startDate', 'endDate'] },
  '/price/day-price/smart-calculate': {
    method: 'POST',
    requestKeys: ['startDate', 'endDate', 'date'],
    responseKeys: ['date'],
  },
  '/price/day-price/calculate': {
    method: 'POST',
    requestKeys: ['startDate', 'endDate'],
    responseKeys: ['date'],
  },
  '/price/day-price/smart-batch-edit': {
    method: 'PUT',
    requestKeys: ['startDate', 'endDate', 'date'],
  },
  '/price/ota/min': { method: 'POST', requestKeys: ['date'] },
  '/price/day-price/batch-edit': { method: 'PUT', requestKeys: ['startDate', 'endDate'] },
  '/priceDiscount/:date': { method: 'GET', responseKeys: ['dayDate'] },
  '/price-update-apply/create': {
    method: 'POST',
    requestKeys: ['startDate', 'endDate', 'promotionStartTime', 'promotionEndTime'],
  },
  '/price-update-apply/calculate': {
    method: 'POST',
    requestKeys: ['startDate', 'endDate', 'promotionStartTime', 'promotionEndTime'],
    responseKeys: ['startDate', 'endDate', 'promotionStartTime', 'promotionEndTime'],
  },
  '/reservation/check': { method: 'POST', requestKeys: ['rentDate'] },
  '/reservation/create': {
    method: 'POST',
    requestKeys: ['rentDate'],
    responseKeys: ['currentTime'],
  },
  '/reservation/modify': { method: 'PUT', requestKeys: ['rentDate'] },
  '/reservation/modify/detail': { method: 'POST', responseKeys: ['rentDate'] },
  '/reservation/detail/:resvNo': { method: 'GET', responseKeys: ['rentDate'] },
  '/reservation/crs-create': {
    method: 'POST',
    requestKeys: ['rentDate'],
    responseKeys: ['currentTime'],
  },
  '/reservation/temp': { method: 'POST', requestKeys: ['rentDate'] },
  '/reservation/temp/detail/:resvNo': { method: 'GET', responseKeys: ['rentDate'] },
  '/reservation/append': {
    method: 'POST',
    requestKeys: ['rentDate'],
    responseKeys: ['currentTime'],
  },
  '/reservation/transferdetail': { method: 'POST', responseKeys: ['rentDate'] },
  '/reservation/transfercreate': { method: 'POST', requestKeys: ['rentDate'] },
  '/reservation/transfercheck': { method: 'POST', requestKeys: ['rentDate'] },
  '/rooms/avail/batch': { method: 'PUT', requestKeys: ['startDate', 'endDate'] },
  '/rooms/change/detail/:recNo': {
    method: 'GET',
    responseKeys: ['businessDate', 'checkoutBusinessDate', 'rentDate'],
  },
  '/rooms/change/check-in/submit': { method: 'POST', requestKeys: ['businessDate'] },
  '/rooms/change/reservation/submit': { method: 'POST', requestKeys: ['businessDate'] },
  '/rooms/clean/export': {
    method: 'POST',
    requestKeys: ['cleanTimeStart', 'cleanTimeEnd', 'createTimeStart', 'createTimeEnd'],
  },
  '/rooms/clean/page': {
    method: 'POST',
    requestKeys: ['cleanTimeStart', 'cleanTimeEnd', 'createTimeStart', 'createTimeEnd'],
  },
  '/rooms/calendar': {
    method: 'POST',
    requestKeys: ['startDate', 'endDate'],
    responseKeys: ['date'],
  },
  '/rooms/disable-info': { method: 'POST', requestKeys: ['date'] },
  '/rooms/future-list': {
    method: 'POST',
    requestKeys: ['startDate', 'endDate'],
    responseKeys: ['date'],
  },
  '/room-inventory/time-rent/shelf': { method: 'POST', requestKeys: ['rentDay'] },
  '/rooms/price/unlock/price/coupon': { method: 'POST', requestKeys: ['rentDate'] },
  '/room-quantity/meituan/search': { method: 'POST', requestKeys: ['startDate', 'endDate'] },
  '/room-quantity/channel/search': { method: 'POST', requestKeys: ['startDate', 'endDate'] },
  '/room-quantity/crs/search': { method: 'POST', requestKeys: ['startDate', 'endDate'] },
  '/sale-card-helper/detail': { method: 'POST', requestKeys: ['startDate', 'endDate'] },
  '/sub/order/list-time-rent': {
    method: 'POST',
    requestKeys: ['businessDate'],
    responseKeys: ['businessDate', 'checkoutBusinessDate', 'rentDate'],
  },
  '/sub/order/rec': {
    method: 'GET',
    responseKeys: ['businessDate', 'checkoutBusinessDate', 'rentDate'],
  },
  '/sub/orderlist/by/condition': {
    method: 'POST',
    responseKeys: ['businessDate', 'checkoutBusinessDate', 'rentDate'],
  },
  '/sub/order/by-room-no': {
    method: 'GET',
    responseKeys: ['businessDate', 'checkoutBusinessDate', 'rentDate'],
  },
  '/sys/current': { method: 'GET', responseKeys: ['businessDate'] },
  '/sys/futureV2': { method: 'POST', responseKeys: ['localDate'] },
  '/sys/future': { method: 'GET', responseKeys: ['localDate'] },
  '/sys/batch/future-business-date': { method: 'POST', responseKeys: ['localDate'] },
  '/transactions/:orderNo': { method: 'GET', responseKeys: ['businessDate'] },
  '/transactions/:no/consume': { method: 'GET', responseKeys: ['businessDate'] },
  '/transactions/search/page': { method: 'POST', responseKeys: ['businessDate'] },
  '/transactions/cross-night-refund/page': { method: 'POST', responseKeys: ['businessDate'] },
  '/zl-extension/zl-detail': { method: 'POST', responseKeys: ['rentDate'] },
};
